import * as React from 'react';
import Box from '../../../parts/Box';
import {
    IInputComponentPropsData,
    IInputComponentPropsFunctions,
} from '../props/IInputComponentProps';
import {
    IInputStructureComponentPropsData,
    IInputStructureComponentPropsFunctions,
} from '../props/IInputStructureComponentProps';
import BioTable from './TableBiologicalUnits';
import {
    Col,
    Button,
    Row,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    FormText,
} from 'reactstrap';
import HelpTooltip from '../../../commons/HelpTooltip';
import axios from 'axios';
import { ll_url } from '../../../tools';
import { examplePDB } from '../../../settings';

type IProps = IInputComponentPropsData &
    IInputComponentPropsFunctions &
    IInputStructureComponentPropsData &
    IInputStructureComponentPropsFunctions & { history: any };

class InputStructureComponent extends React.Component<IProps> {
    infoRef = React.createRef<HTMLFormElement>();

    state = {
        button: true,
        enterPdbHidden: false,
        uploadPdbHidden: true,
        showChainsSelection: false,
        list: [],
        pdbFile: null,
    };

    componentDidUpdate(prevProps: IProps) {
        if (this.props.selectedStructureInfo !== prevProps.selectedStructureInfo) {
            if (this.props.selectedStructureInfo !== null) {
                this.props.setSpecifyChainsManually(false);
            }
        }
    }

    handleShowEnterPdbBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            enterPdbHidden: false,
            uploadPdbHidden: true,
        });
    };

    handleShowUploadPdbBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            enterPdbHidden: true,
            uploadPdbHidden: false,
        });
    };
    handleStructureFromID = async () => {
        var regex = /^[a-zA-Z0-9]{4}$/;
        if(regex.test(this.props.pdbIdField)){
            await this.props.structureFromID(this.props.pdbIdField, this.props.jobId);
        }
        else{
            alert("Given ID is not a correct PDB ID format.");
        }
    };

    handlePdbFile = (file) => {
        this.props.handlePdbFile(file, this.props.jobId);
    };

    handleChainChange = (ev) => {
        const chain = ev.target.dataset.chain;
        const checked = ev.target.checked;
        if (checked) {
            this.props.setSelectedChains([
                ...this.props.selectedChains,
                chain,
            ]);
        } else {
            this.props.setSelectedChains(this.props.selectedChains.filter(c => c !== chain));
        }
    }

    handleManualSelection = (ev) => {
        const checked = ev.target.checked;
        this.props.setSpecifyChainsManually(checked);
    }

    handleLoadExample = () => {
        this.props.changePdbIdField(examplePDB);
        this.props.structureFromID(examplePDB, this.props.jobId);
    }

    render() {

        return (
            <div>
                <Box title='INPUT STRUCTURE' button={
                  <Button className = "ll-example-button" onClick={this.handleLoadExample}>Load example</Button>
                }>
                    <div>
                            <FormGroup tag='fieldset' row>
                                <Label
                                    for='source_radio'
                                    style={{ color: '#09A0A8', fontWeight: 'bold' }}
                                    sm={2}>
                                    Source:
                                </Label>
                                <Col sm={10}>
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type='radio'
                                                name='op1'
                                                value='1'
                                                defaultChecked
                                                onClick={this.handleShowEnterPdbBox}
                                            />{' '}
                                            Enter PDB code
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type='radio'
                                                name='op1'
                                                value='2'
                                                onClick={this.handleShowUploadPdbBox}
                                            />{' '}
                                            Upload PDB file
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </FormGroup>

                            {this.state.enterPdbHidden ? null : (
                                <FormGroup tag='fieldset' row>
                                    <Col>
                                        <Row>
                                            <Label
                                                htmlFor='pbdIdField'
                                                style={{ color: '#09A0A8', fontWeight: 'bold' }}
                                                sm={2}>
                                                PDB ID:
                                                <HelpTooltip>
                                                    Insert PDB ID of your target structure and click the
                                                    "Process structure" button.
                                                </HelpTooltip>
                                            </Label>
                                            <Col>
                                                <Row>
                                                    <Col sm={10}>
                                                        <div className='form-group'>
                                                            <Input
                                                                type='text'
                                                                className='form-control'
                                                                id='uniprot_id'
                                                                style={{width: '150px', height: '30px'}}
                                                                value={this.props.pdbIdField}
                                                                onChange={(evt) =>
                                                                    this.props.changePdbIdField(evt.target.value)
                                                                }
                                                            />
                                                        </div>
                                                        <Button onClick={this.handleStructureFromID}>
                                                            Process structure
                                                        </Button>
                                                        {!this.props.showLoadingMsg ? null :
                                                            <img src={ll_url("/images/working.gif")}/>
                                                        }
                                                        {!this.props.processedStructure.nmr ? null :
                                                            <Label style={{ paddingLeft:'5px', color: '#f24423', fontWeight: 'bold' }}>
                                                                Multi-model PDB on input
                                                                <HelpTooltip>FireProt chooses always the first model, but finds no Biological units. Please select chains manually.</HelpTooltip>
                                                            </Label>
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </FormGroup>
                            )}

                            {this.state.uploadPdbHidden ? null : (
                                <FormGroup tag='fieldset' row>
                                    <Label
                                        htmlFor='pbdIdField'
                                        style={{ color: '#09A0A8', fontWeight: 'bold' }}
                                        sm={2}>
                                        PDB FILE:
                                        <HelpTooltip>Choose your file.</HelpTooltip>
                                    </Label>
                                    <Col>
                                        <Row>
                                            <Col sm={10}>
                                                <FormGroup>
                                                    <Input
                                                        id='upload_pbd_file'
                                                        name='file'
                                                        type='file'
                                                        onChange={(evt) =>
                                                            this.handlePdbFile(evt.target.files[0])
                                                        }
                                                    />
                                                    <FormText>
                                                        Upload protein structure file. (.pdb)
                                                    </FormText>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </FormGroup>
                            )}

                            <FormGroup tag='fieldset' row>
                                <Label
                                    for='biological_unit'
                                    style={{ color: '#09A0A8', fontWeight: 'bold' }}
                                    sm={2}>
                                    Biological unit:
                                    <HelpTooltip>
                                        Select biological unit for which the FireProt
                                        calculation should be performed.
                                    </HelpTooltip>
                                </Label>
                                <Col sm={10}>
                                    <BioTable
                                        data={this.props.processedStructure.structures}
                                        setSelectedRowsF={this.props.setSelectedStructureInfo}
                                        unselectAll={this.props.specifyChainsManually}
                                        jobId={this.props.jobId}
                                        // selected={this.props.selectedStructureInfo}
                                    />
                                    <FormGroup check>
                                        {this.props.showChainsSelection == false ? null :
                                        <Label check>
                                            <Input type='checkbox'
                                                checked={this.props.specifyChainsManually}
                                                onChange={this.handleManualSelection}
                                            /> Specify chains
                                            manually
                                        </Label>
                                        }
                                    </FormGroup>

                                <FormGroup>
                                    {this.props.specifyChainsManually && this.props.chains && (
                                        this.props.chains.map(chain => (
                                            <label key={chain}>
                                                <input
                                                    type="checkbox"
                                                    data-chain={chain}
                                                    onChange={this.handleChainChange}
                                                    checked={this.props.selectedChains.includes(chain)}
                                                />
                                                {"\u00A0" + chain + "\u00A0\u00A0\u00A0"}
                                            </label>
                                        )
                                    ))}
                                </FormGroup>
                                </Col>
                            </FormGroup>
                        
                    </div>
                </Box>
            </div>
        );
    }
}
export default InputStructureComponent;
